export async function customInstance(urlOrConfig, init) {
    const cfg = typeof urlOrConfig === "string"
        ? { url: urlOrConfig, ...(init || {}) }
        : urlOrConfig;
    const base = cfg.baseUrl?.replace(/\/$/, "") ?? "";
    const url = `${base}${cfg.url}`;
    const { baseUrl, ...requestInit } = cfg;
    const method = (requestInit.method || "GET").toUpperCase();
    const headers = buildAuthHeaders(method, requestInit.headers);
    const res = await fetch(url, {
        ...requestInit,
        headers,
        credentials: "include",
    });
    let data = null;
    const contentType = res.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
        try {
            data = await res.json();
        }
        catch {
            data = null;
        }
    }
    else if (contentType.startsWith("text/")) {
        data = await res.text();
    }
    return { data: data, headers: res.headers, status: res.status };
}
export function buildAuthHeaders(method, baseHeaders) {
    const headers = new Headers(baseHeaders);
    if (needsCsrfHeader(method)) {
        const csrf = getCsrfToken();
        if (csrf)
            headers.set(getCsrfHeaderName(), csrf);
    }
    return headers;
}
export function getCookie(name) {
    if (typeof document === "undefined")
        return null;
    const match = document.cookie
        .split(";")
        .map((s) => s.trim())
        .find((c) => c.startsWith(`${name}=`));
    if (!match)
        return null;
    try {
        return decodeURIComponent(match.split("=")[1] || "");
    }
    catch {
        return match.split("=")[1] || "";
    }
}
export function getCsrfCookieName() {
    // Library-level default; apps can override at their layer
    return "CSRF-TOKEN";
}
export function getCsrfHeaderName() {
    return "X-CSRF-TOKEN";
}
export function getCsrfToken() {
    return getCookie(getCsrfCookieName());
}
function needsCsrfHeader(method) {
    const upper = method.toUpperCase();
    return ["POST", "PUT", "PATCH", "DELETE"].includes(upper);
}
